import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { DocumentField } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getAllTenantFieldTypes = async () => {
  if (isMockServices())
    return (await mock(_mockAllTenantFieldTypes)).fieldTypes;

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    status: string;
    fieldTypes: DocumentField[];
  }>('/field-types', {
    method: 'GET',
    paginate: true,
    accumulateKey: 'fieldTypes',
    nextCursorKey: 'nextCursor',
    limit: 100,
  });

  if (response.data) {
    return response.data.fieldTypes.filter((field) => field.inUse);
  }

  throw new Error('Failed to fetch all tenant document fields');
};

export default getAllTenantFieldTypes;

const _mockAllTenantFieldTypes = {
  fieldTypes: new Array(10).fill(null).map((_, index) => ({
    id: `field-${index}`,
    name: `Field ${index + 1}`,
    documentTypeId: `document-type-id-${index % 3}`,
    inUse: true,
    isDeleted: false,
    type: index % 2 === 0 ? 'text' : 'number',
    code: `FIELD_CODE_${index + 1}`,
    description: `Description for Field ${index + 1}`,
    displayName: `Display Field ${index + 1}`,
  })) as DocumentField[],
};
